import { z } from 'zod';

export const WEBHOOK_EVENTS = [
  'lead.created',
  'lead.recontacted',
  'lead.assigned',
  'lead.stage_changed',
  'lead.desisted',
  'lead.reopened',
  'appointment.confirmed',
  'task.handoff',
  'deal.created',
  'deal.refunded',
  'contact.opted_out',
  'message.inbound',
  'message.outbound',
  'message.status',
  'attention.changed',
  'attention.resumed',
] as const;
export type WebhookEvent = (typeof WEBHOOK_EVENTS)[number];

export const WEBHOOK_EVENT_LABELS: Record<WebhookEvent, string> = {
  'lead.created': 'Lead creado',
  'lead.recontacted': 'La persona volvió a registrarse sobre un lead activo',
  'lead.assigned': 'Lead asignado / reasignado',
  'lead.stage_changed': 'Cambio de etapa',
  'lead.desisted': 'Lead desistido',
  'lead.reopened': 'Lead reabierto',
  'appointment.confirmed': 'Cita concretada (visita registrada)',
  'task.handoff': 'Handoff del bot a un asesor',
  'deal.created': 'Separación o venta registrada',
  'deal.refunded': 'Devolución / anulación de un proceso',
  'contact.opted_out': 'El contacto pidió no ser contactado',
  'message.inbound': 'Mensaje entrante de WhatsApp (Cloud API)',
  'message.outbound': 'Mensaje enviado por WhatsApp',
  'message.status': 'Estado de entrega de un mensaje',
  'attention.changed': 'Atención del bot: cambio de estado o de dueño (pausa por un humano)',
  'attention.resumed': 'Atención del bot: el bot retoma tras la pausa del asesor',
};

export const webhookSubscriptionSchema = z.object({
  companyId: z.string().uuid(),
  name: z.string().trim().min(2).max(80),
  url: z.string().url('URL inválida').max(500),
  events: z.array(z.enum(WEBHOOK_EVENTS)).min(1, 'Elige al menos un evento'),
  active: z.boolean().default(true),
});
export type WebhookSubscriptionInput = z.infer<typeof webhookSubscriptionSchema>;
export type WebhookSubscriptionPayload = z.input<typeof webhookSubscriptionSchema>;

export interface WebhookSubscriptionDto extends WebhookSubscriptionInput {
  id: string;
  /** Solo se devuelve completo al crear; después, prefijo. */
  secret?: string;
  secretPrefix: string;
  createdAt: string;
  lastDeliveryAt: string | null;
  failing: number;
}

export interface WebhookDeliveryDto {
  id: string;
  subscriptionId: string;
  subscriptionName: string;
  event: WebhookEvent;
  status: 'PENDIENTE' | 'ENTREGADO' | 'FALLIDO';
  attempts: number;
  lastError: string | null;
  responseStatus: number | null;
  nextAttemptAt: string | null;
  deliveredAt: string | null;
  createdAt: string;
  payload: unknown;
}
